import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  alert,
  float,
  toFixed,
  GET,
  POST,
  PUT,
  loading,
  required,
  Select,
  Pagination,
  Switch,
  Navbar,
  Modal,
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";
import GatewayLogo from "../../components/GatewayLogo.js";

// Gold-accented toggle to match the premium theme (same as the other pages).
const SWITCH_PROPS = {
  onColor: "#c9a23a",
  offColor: "#cbd5e1",
  onHandleColor: "#ffffff",
  checkedIcon: false,
  uncheckedIcon: false,
  height: 22,
  width: 42,
  handleDiameter: 16,
  activeBoxShadow: "0 0 0 3px rgba(212, 175, 55, 0.3)",
};
export default class Gateways extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      data: [],
      loaded: false,
      count: 10,

      id: "",
      uid: "",
      gateway_name: "",
      gateway_code: "",
      country: "THB",
      deposits_limit_amount: "",
      withdrawals_limit_amount: "",
      fee_type_deposits: "",
      fee_type_withdrawals: "",
      deposits_fee_value: "",
      withdrawals_fee_value: "",
      payment_min_deposit: "",
      payment_max_deposit: "",
      payment_min_withdrawal: "",
      payment_max_withdrawal: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("gateway-rules/list", {
        page_size: 10,
        page: page,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      count,
      loaded: true,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      gateway_name,
      gateway_code,
      country,
      is_deposit_active,
      is_withdrawal_active,
      deposits_limit_amount,
      withdrawals_limit_amount,
      fee_type_deposits,
      fee_type_withdrawals,
      deposits_fee_value,
      withdrawals_fee_value,
      payment_min_deposit,
      payment_max_deposit,
      payment_min_withdrawal,
      payment_max_withdrawal,
    } = this.state;
    // gateway_code + country คือคู่ที่ SelectGateWay ใช้หา rule ตอนสร้างรายการ ขาดไม่ได้
    if (!gateway_name?.trim() || !gateway_code?.trim() || !country || !fee_type_deposits || !fee_type_withdrawals) {
      alert("", "warning", "Warning", "Please fill in gateway name, code, currency and fee types.");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        gateway_name: gateway_name.trim().toLowerCase(),
        gateway_code: gateway_code.trim().toLowerCase(),
        country: country.toUpperCase(),
        is_deposit_active: !!is_deposit_active,
        is_withdrawal_active: !!is_withdrawal_active,
        deposits_limit_amount: Number(deposits_limit_amount),
        withdrawals_limit_amount: Number(withdrawals_limit_amount),
        fee_type_deposits,
        fee_type_withdrawals,
        deposits_fee_value: Number(deposits_fee_value),
        withdrawals_fee_value: Number(withdrawals_fee_value),
        payment_min_deposit: Number(payment_min_deposit),
        payment_max_deposit: Number(payment_max_deposit),
        payment_min_withdrawal: Number(payment_min_withdrawal),
        payment_max_withdrawal: Number(payment_max_withdrawal),
      };

      let result = !uid
        ? await POST("gateway-rules/create", body)
        : await PUT("gateway-rules/update/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  // -------------------------------------------------------------------------
  // Render helpers (presentation only — handlers and payload unchanged)
  // -------------------------------------------------------------------------
  // ค่าตั้งต้นของ gateway ใหม่: THB, เปิดฝาก ปิดถอน, ค่าธรรมเนียมแบบ % ยอดต่าง ๆ ให้กรอกเอง
  openCreate = () => {
    this.setState({
      modal_create: true,
      modal_update: false,
      id: "",
      uid: "",
      gateway_name: "",
      gateway_code: "",
      country: "THB",
      is_deposit_active: true,
      is_withdrawal_active: false,
      deposits_limit_amount: "",
      withdrawals_limit_amount: "",
      fee_type_deposits: "percentage",
      fee_type_withdrawals: "percentage",
      deposits_fee_value: "",
      withdrawals_fee_value: "",
      payment_min_deposit: "",
      payment_max_deposit: "",
      payment_min_withdrawal: "",
      payment_max_withdrawal: "",
    });
  };
  openUpdate = (item) => {
    this.setState({
      ...item,
      deposits_limit_amount: Number(item.deposits_limit_amount),
      withdrawals_limit_amount: Number(item.withdrawals_limit_amount),
      deposits_fee_value: Number(item.deposits_fee_value),
      withdrawals_fee_value: Number(item.withdrawals_fee_value),
      payment_min_deposit: Number(item.payment_min_deposit),
      payment_max_deposit: Number(item.payment_max_deposit),
      payment_min_withdrawal: Number(item.payment_min_withdrawal),
      payment_max_withdrawal: Number(item.payment_max_withdrawal),
      modal_update: true,
    });
  };
  closeModal = () => {
    this.setState({ modal_create: false, modal_update: false });
  };
  renderToggle = ({ icon, title, desc, checked, onChange }) => (
    <label className={`pu-toggle ${checked ? "on" : ""}`}>
      <span className="pu-toggle-icon icon">{icon}</span>
      <span className="flex-grow-1 min-w-0">
        <span className="pu-toggle-title">{title}</span>
        <span className="pu-toggle-desc">{desc}</span>
      </span>
      <Switch {...SWITCH_PROPS} onChange={onChange} checked={!!checked} />
    </label>
  );
  feeCell = (value, type) => (
    <span className="pu-fee-cell">
      {toFixed(value) || "0.00"}
      <span className={`pu-fee-unit ${type === "percentage" ? "pct" : ""}`}>
        {type === "percentage" ? "%" : "THB"}
      </span>
    </span>
  );
  render() {
    const {
      modal_create,
      modal_update,
      data,
      loaded,
      count,
      gateway_name,
      gateway_code,
      country,
      is_deposit_active,
      is_withdrawal_active,
      deposits_limit_amount,
      withdrawals_limit_amount,
      fee_type_deposits,
      fee_type_withdrawals,
      deposits_fee_value,
      withdrawals_fee_value,
      payment_min_deposit,
      payment_max_deposit,
      payment_min_withdrawal,
      payment_max_withdrawal,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const countryOptions = ["THB", "LAK"].map((e) => ({ value: e, label: e }));
    const feeTypeOptions = ["percentage", "fixed"].map((e) => ({
      value: e,
      label: e,
    }));
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Configuration</div>
                <div className="ar-title">Gateway Settings</div>
                <div className="ar-subtitle">
                  Configure payment gateway limits and fee structures for
                  deposits and withdrawals.
                </div>
              </div>
              <div className="ar-hero-actions">
                <div className="d-none d-md-flex align-items-center gap-3 pu-hero-legend">
                  <span>
                    <i className="ar-legend-dot ar-legend-dep"></i>Deposits
                  </span>
                  <span>
                    <i className="ar-legend-dot ar-legend-wd"></i>Withdrawals
                  </span>
                </div>
                <button className="ar-btn-gold gateway-rules.create" onClick={this.openCreate}>
                  <span className="icon me-2">{"\uf067"}</span>Create Gateway
                </button>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Gateway Rules
                </div>
                <div className="ar-table-caption">
                  {count || 0} gateway{count === 1 ? "" : "s"} · showing{" "}
                  {rows.length} on this page
                </div>
              </div>
              <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <span className="pu-legend-dot on" />
                  Channel active
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Channel inactive
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap ar-table pu-table">
                <thead>
                  <tr>
                    <td className="align-middle" rowSpan={2}>
                      Gateway
                    </td>
                    <td className="text-center ar-group ar-group-dep ar-group-start" colSpan={4}>
                      <span className="icon me-2">{""}</span>Deposits
                    </td>
                    <td className="text-center ar-group ar-group-wd ar-group-start" colSpan={4}>
                      <span className="icon me-2">{""}</span>Withdrawals
                    </td>
                    <td className="text-center align-middle gateway-rules.update td-actions" rowSpan={2}>
                      Actions
                    </td>
                  </tr>
                  <tr>
                    <td className="text-end ar-group-start">Limit Amount</td>
                    <td className="text-end">Fee</td>
                    <td className="text-end">Min</td>
                    <td className="text-end">Max</td>
                    <td className="text-end ar-group-start">Limit Amount</td>
                    <td className="text-end">Fee</td>
                    <td className="text-end">Min</td>
                    <td className="text-end">Max</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => (
                    <tr key={item.uid || `array-${index}`}>
                      <td data-label="Gateway Name">
                        <div className="pu-gateway">
                          <GatewayLogo name={item.gateway_name} size={30} />
                          <div className="min-w-0">
                            <div className="pu-gateway-name">
                              <span className="text-truncate">{item.gateway_name || "-"}</span>
                            </div>
                            <div className="pu-sub">
                              <span
                                className={`pu-legend-dot ${item.is_deposit_active ? "on" : "off"}`}
                                title={item.is_deposit_active ? "Deposit active" : "Deposit inactive"}
                              />
                              <span className="me-2">Dep</span>
                              <span
                                className={`pu-legend-dot ${item.is_withdrawal_active ? "on" : "off"}`}
                                title={item.is_withdrawal_active ? "Withdrawal active" : "Withdrawal inactive"}
                              />
                              <span>Wd</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td data-label="Deposit Limit" className="text-end ar-group-start pu-num fw-bold">
                        {toFixed(item.deposits_limit_amount, 2)}
                      </td>
                      <td data-label="Deposit Fee" className="text-end">
                        {this.feeCell(item.deposits_fee_value, item.fee_type_deposits)}
                      </td>
                      <td data-label="Deposit Min" className="text-end ar-muted">
                        {toFixed(item.payment_min_deposit) || "0.00"}
                      </td>
                      <td data-label="Deposit Max" className="text-end ar-muted">
                        {toFixed(item.payment_max_deposit) || "0.00"}
                      </td>
                      <td data-label="Withdraw Limit" className="text-end ar-group-start pu-num fw-bold">
                        {toFixed(item.withdrawals_limit_amount, 2)}
                      </td>
                      <td data-label="Withdraw Fee" className="text-end">
                        {this.feeCell(item.withdrawals_fee_value, item.fee_type_withdrawals)}
                      </td>
                      <td data-label="Withdraw Min" className="text-end ar-muted">
                        {toFixed(item.payment_min_withdrawal) || "0.00"}
                      </td>
                      <td data-label="Withdraw Max" className="text-end ar-muted">
                        {toFixed(item.payment_max_withdrawal) || "0.00"}
                      </td>
                      <td data-label="Actions" className="text-center gateway-rules.update td-actions">
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`gateway-actions-${index}`}>
                            Action
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                          <Dropdown.Item
                            className="pu-action-item gateway-rules.update"
                            onClick={() => this.openUpdate(item)}
                          >
                            <span className="icon">{"\uf044"}</span>Update
                          </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={10} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No gateways found</div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={this.closeModal}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div className="d-flex align-items-center gap-3">
              <div className="pu-modal-logo">
                <GatewayLogo name={gateway_name} size={36} />
              </div>
              <div>
                <div className="pr-modal-eyebrow">
                  {modal_create ? "New gateway" : "Edit gateway"}
                </div>
                <h5 className="fw-bold mb-0">
                  {modal_create ? "Create" : modal_update ? "Update" : ""} Gateway
                  {gateway_name ? ` · ${gateway_name}` : ""}
                </h5>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {/* IDENTITY */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Gateway
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Gateway Name{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Gateway name"
                    onChange={(e) => {
                      this.setState({ gateway_name: e.target.value });
                    }}
                    value={gateway_name}
                    disabled={modal_update}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Gateway Code{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Gateway code"
                    onChange={(e) => {
                      this.setState({ gateway_code: e.target.value });
                    }}
                    value={gateway_code}
                    disabled={modal_update}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Currency{required}</label>
                  <Select
                    className="form-control pr-input"
                    placeholder="Currency"
                    options={countryOptions}
                    onChange={(e) => this.setState({ country: e })}
                    value={country}
                    disabled={modal_update}
                  />
                </div>
              </div>
              {modal_create && (
                <div className="pu-hint">
                  Code must match the gateway key used by the system (e.g. primerlo) and the currency it serves.
                </div>
              )}
              {modal_update && (
                <div className="pu-hint">
                  Name, code and currency identify the gateway and cannot be changed here.
                </div>
              )}
            </div>

            <div className="row g-3">
              {/* DEPOSIT */}
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-dep h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Deposit
                  </div>
                  <div className="mb-3">
                    {this.renderToggle({
                      icon: "",
                      title: "Active",
                      desc: "Accept deposits through this gateway",
                      checked: is_deposit_active,
                      onChange: (e) => this.setState({ is_deposit_active: e }),
                    })}
                  </div>
                  <div className="mb-3">
                    <label className="pr-label">Limit Amount{required}</label>
                    <NumericFormat
                      thousandSeparator=","
                      decimalScale={2}
                      type="text"
                      className="form-control pr-input"
                      placeholder="0.00"
                      value={deposits_limit_amount}
                      onValueChange={(values) => this.setState({ deposits_limit_amount: values.value })}
                    />
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <label className="pr-label">Fee Type{required}</label>
                      <Select
                        className="form-control pr-input"
                        placeholder="Fee type"
                        options={feeTypeOptions}
                        onChange={(e) => {
                          this.setState({
                            fee_type_deposits: e,
                            deposits_fee_value:
                              e === "fixed" && fee_type_withdrawals === "fixed"
                                ? "00.00"
                                : deposits_fee_value,
                            withdrawals_fee_value:
                              e === "percentage" &&
                              fee_type_withdrawals === "percentage"
                                ? "00.00"
                                : withdrawals_fee_value,
                          });
                        }}
                        value={fee_type_deposits}
                      />
                    </div>
                    <div className="col-6">
                      <label className="pr-label">Fee{required}</label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control pr-input pe-5"
                          placeholder="0.00"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            this.setState({ deposits_fee_value: e.target.value });
                          }}
                          value={deposits_fee_value}
                        />
                        <span className="pu-input-suffix">
                          {fee_type_deposits === "percentage" ? "%" : "THB"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="col-6">
                      <label className="pr-label">Min{required}</label>
                      <NumericFormat
                        thousandSeparator=","
                        decimalScale={2}
                        type="text"
                        className="form-control pr-input"
                        placeholder="0.00"
                        maxLength={10}
                        value={payment_min_deposit}
                        onValueChange={(values) => this.setState({ payment_min_deposit: values.value })}
                      />
                    </div>
                    <div className="col-6">
                      <label className="pr-label">Max{required}</label>
                      <NumericFormat
                        thousandSeparator=","
                        decimalScale={2}
                        type="text"
                        className="form-control pr-input"
                        placeholder="0.00"
                        maxLength={10}
                        value={payment_max_deposit}
                        onValueChange={(values) => this.setState({ payment_max_deposit: values.value })}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* WITHDRAWAL */}
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-wd h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Withdrawal
                  </div>
                  <div className="mb-3">
                    {this.renderToggle({
                      icon: "",
                      title: "Active",
                      desc: "Allow withdrawals through this gateway",
                      checked: is_withdrawal_active,
                      onChange: (e) => this.setState({ is_withdrawal_active: e }),
                    })}
                  </div>
                  <div className="mb-3">
                    <label className="pr-label">Limit Amount{required}</label>
                    <NumericFormat
                      thousandSeparator=","
                      decimalScale={2}
                      type="text"
                      className="form-control pr-input"
                      placeholder="0.00"
                      value={withdrawals_limit_amount}
                      onValueChange={(values) => this.setState({ withdrawals_limit_amount: values.value })}
                    />
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <label className="pr-label">Fee Type{required}</label>
                      <Select
                        className="form-control pr-input"
                        placeholder="Fee type"
                        options={feeTypeOptions}
                        onChange={(e) => {
                          this.setState({
                            fee_type_withdrawals: e,
                            deposits_fee_value:
                              e === "fixed" && fee_type_deposits === "fixed"
                                ? "00.00"
                                : deposits_fee_value,
                            withdrawals_fee_value:
                              e === "percentage" &&
                              fee_type_deposits === "percentage"
                                ? "00.00"
                                : withdrawals_fee_value,
                          });
                        }}
                        value={fee_type_withdrawals}
                      />
                    </div>
                    <div className="col-6">
                      <label className="pr-label">Fee{required}</label>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control pr-input pe-5"
                          placeholder="0.00"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            this.setState({ withdrawals_fee_value: e.target.value });
                          }}
                          value={withdrawals_fee_value}
                        />
                        <span className="pu-input-suffix">
                          {fee_type_withdrawals === "percentage" ? "%" : "THB"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="col-6">
                      <label className="pr-label">Min{required}</label>
                      <NumericFormat
                        thousandSeparator=","
                        decimalScale={2}
                        type="text"
                        className="form-control pr-input"
                        placeholder="0.00"
                        maxLength={10}
                        value={payment_min_withdrawal}
                        onValueChange={(values) => this.setState({ payment_min_withdrawal: values.value })}
                      />
                    </div>
                    <div className="col-6">
                      <label className="pr-label">Max{required}</label>
                      <NumericFormat
                        thousandSeparator=","
                        decimalScale={2}
                        type="text"
                        className="form-control pr-input"
                        placeholder="0.00"
                        maxLength={10}
                        value={payment_max_withdrawal}
                        onValueChange={(values) => this.setState({ payment_max_withdrawal: values.value })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={this.closeModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
